import React from 'react';
import { Container } from 'reactstrap';
import Wizard from 'components/Forms/Wizard/Wizard';

function IndexRefactored() {
  return (
    <Container className="mt-4" fluid>
      <Wizard MODE="MERCHANT" />
    </Container>
  );
}

export default IndexRefactored;
